import React, { Component, useState } from 'react';
import { CSVReader, readRemoteFile } from 'react-papaparse';
import { Button, Grid, Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { DialogTitleHeader } from '../GlobalStyles/DialogStyle';
import OpenInBrowserIcon from '@material-ui/icons/OpenInBrowser';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import FtpFiles from './FtpFiles';

const titleHeader = {
  fontWeight: 'bold',
  marginTop: '5px',
  fontSize: 17
};

const browseButton = {
  borderRadius: 5,
  paddingTop: '6px',
  paddingBottom: '6px',
  marginTop: '0.8cm',
  marginBottom: '0.8cm',
  fontSize: 13,
  fontWeight: 600,
  marginLeft: '1.5cm',
};

const upload = {
  borderRadius: 5,
  float: 'left',
  marginLeft: '1.8cm',
  paddingBottom: "8px",
  paddingTop: "8px",
  fontWeight: 'bold',
  fontSize: 12,
  width: '160px'
}

const buttonRef = React.createRef();
export default class CSVFileReader extends Component {

  handleOpenDialog = (e) => {
    // Note that the ref is set async, so it might be null at some point
    if (buttonRef.current) {
      buttonRef.current.open(e);
    }
  };

  handleOnFileLoad = (data) => {
    this.props.csvUpload(data);
  };

  handleCloudCSVFileUpload = (data, fileExist) => {
    this.props.cloudUpload(data, fileExist);
  }

  handleOnError = (err, file, inputElem, reason) => {
    console.log('---------------------------');
    console.log(err);
    console.log('---------------------------');
  };

  constructor(props) {
    super(props);
    this.state = {}
    this.handleOpenDialogBox = this.handleOpenDialogBox.bind(this);
    this.onUploadFile = this.onUploadFile.bind(this);
    this.handleCloseDialogBox = this.handleCloseDialogBox.bind(this);
    this.state = { fileuploaded: false }
  }

  handleOpenDialogBox() {
    this.setState({
      openDialog: true
    });
  }

  handleCloseDialogBox() {
    this.setState({
      openDialog: false
    });
  }

  onUploadFile = (file) => {
    if (file !== null) {
      this.props.fileUpload(file);
    }
  }

  onCloudUploadFile = (file) => {
    if (file !== null) {
      this.props.CloudfileUpload(file);
    }
  }

  render() {
    return (
      <>
        <Button variant="contained" color="primary" disabled={this.props.disabled || this.props.disableIsActive}
          size="small" style={upload} onClick={this.handleOpenDialogBox} startIcon={<CloudUploadIcon style={{ fontSize: 23 }} />}>
          Map CSV
        </Button>
        <Dialog open={this.state.openDialog} maxWidth={'xs'} aria-labelledby="responsive-dialog-title" PaperProps={{ style: { borderRadius: 10 } }} >
          <DialogTitleHeader id="responsive-dialog-title" onClose={this.handleCloseDialogBox}>
            <Typography variant="h6" gutterBottom style={titleHeader}>
              CHOOSE PLACEMENT METHOD
            </Typography>
          </DialogTitleHeader>
          <DialogContent>
            <Grid container spacing={0}>
              <Grid item xs={6} >
                <CSVReader ref={buttonRef} onFileLoad={this.handleOnFileLoad}
                  onError={this.handleOnError} skipEmptyLines={true} header={false} accept={['text/*', '.csv']}
                  noClick noDrag config={{
                    delimiter: "",  // auto-detect
                    newline: "",  // auto-detect
                    quoteChar: '"',
                    escapeChar: '"',
                    header: false,
                    transformHeader: undefined,
                    dynamicTyping: false,
                    preview: 0,
                    encoding: "",
                    worker: false,
                    comments: "{",
                    step: undefined,
                    complete: undefined,
                    error: undefined,
                    download: false,
                    downloadRequestHeaders: undefined,
                    skipEmptyLines: "greedy", // 'greedy' -> To remove the rows which has empty and white space in the CSV file while uploading.
                    chunk: undefined,
                    fastMode: undefined,
                    beforeFirstChunk: undefined,
                    withCredentials: undefined,
                    transform: undefined,
                    delimitersToGuess: [',', '	', '|', ';', '\t']
                  }}
                >
                  {({ file }) => (
                    <>
                      <Button size="small" style={browseButton} startIcon={<OpenInBrowserIcon style={{ fontSize: 25 }} />}
                        variant="contained" color="primary" component="span" onClick={this.handleOpenDialog}>
                        Browse File
                      </Button>
                      {this.onUploadFile(file)}
                    </>
                  )}
                </CSVReader>
              </Grid>
              <Grid item xs={6}>
                <FtpFiles onRemoteFileUpload={this.handleCloudCSVFileUpload} getPhase={this.props.getphase} getClients={this.props.getClientCode} onCloudUpload={this.onCloudUploadFile} />
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
      </>
    );
  }
}
